import React, { useState, useEffect } from "react";
import "./index.css";

const Toast = ({ message, type = "success", duration = 3000, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) setTimeout(onClose, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div
      className={`toast-notification ${type} ${visible ? "show" : "hide"}`}
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        padding: "12px 20px",
        borderRadius: "8px",
        backgroundColor: type === "success" ? "#4CAF50" : "#f44336",
        color: "white",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
        zIndex: 1000,
        minWidth: "250px",
        transition: "opacity 0.3s, transform 0.3s",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(-20px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div>
        {type === "success" && <span style={{ marginRight: "8px" }}>✓</span>}
        {type === "error" && <span style={{ marginRight: "8px" }}>✗</span>}
        {message}
      </div>
      <button
        onClick={() => {
          setVisible(false);
          if (onClose) setTimeout(onClose, 300);
        }}
        style={{
          background: "none",
          border: "none",
          color: "white",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "16px",
          marginLeft: "10px",
        }}
      >
        ×
      </button>
    </div>
  );
};

export default Toast;
